import { useState } from 'react';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUrl } from '../api/client';
import { useT } from '../lib/i18n';

/**
 * Public entry point served at onboarding.ciimar.up.pt: a new member types the
 * code they were given, or a CIIMAR staff member signs in to the portal.
 */
export function OnboardingLanding() {
  const navigate = useNavigate();
  const t = useT();
  const [code, setCode] = useState('');

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (trimmed) navigate(`/iamnew?code=${encodeURIComponent(trimmed)}`);
  }

  return (
    <div className="public-page">
      <div className="card narrow">
        <h1>{t('auth.landing.title')}</h1>
        <p className="muted">{t('auth.landing.subtitle')}</p>

        <form onSubmit={onSubmit}>
          <label>
            {t('auth.landing.codeLabel')}
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoComplete="off"
              autoCapitalize="characters"
              placeholder={t('auth.landing.codePlaceholder')}
              style={{ textTransform: 'uppercase', letterSpacing: '0.15em' }}
            />
          </label>
          <button type="submit" disabled={!code.trim()}>
            {t('auth.landing.continue')}
          </button>
        </form>

        <hr className="divider" />

        <p className="muted">{t('auth.landing.memberPrompt')}</p>
        <a href={loginUrl()}>
          <button type="button" className="secondary">
            {t('auth.landing.enterPortal')}
          </button>
        </a>
      </div>
    </div>
  );
}
